import { IDynamicRenderControl } from '../models/dynamic-render-control'
import { ComponentRef, Injector, Type } from '@angular/core'
import { IDynamicRenderProps } from '../models/dynamic-render-props'
import { IArrayMap } from '@adex/shared/models/array-map'
import { Subject } from 'rxjs'


export class DynamicRenderControl<C> implements IDynamicRenderControl<C> {
  private componentRef?: ComponentRef<C>
  private containerName?: string

  public isOpen = false
  public readonly destroy$: Subject<void> = new Subject()

  constructor(
    public readonly name: string,
    public readonly componentType: Type<C>,
    public componentProps?: IDynamicRenderProps,
    public readonly parentInjector?: Injector
  ) {
  }

  public setComponentRef(ref: ComponentRef<C>): void {
    this.componentRef = ref
  }

  public getComponentRef(): ComponentRef<C> {
    return this.componentRef
  }

  public setContainerName(name: string): void {
    this.containerName = name
  }

  public getContainerName(): string {
    return this.containerName
  }

  public open(): void {
    this.isOpen = true
  }

  public close(): void {
    this.isOpen = false
  }

  public updateInputs(inputs: IArrayMap<any>) {
    this.componentProps.inputs = { ...(this.componentProps?.inputs || {}), ...inputs }
    this.innerUpdateInputs()
  }

  private innerUpdateInputs() {
    const ref = this.getComponentRef()
    if (!ref) return
    const instance = ref.instance as any
    if (!instance) return
    const inputs = this.componentProps?.inputs || {}
    const keys = Object.keys(inputs)
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i]
      const value = Reflect.get(inputs, key)
      Reflect.set(instance, key, value)
    }
  }
}
